<div>
    <div mat-dialog-title oneDialogTitle>
        <span i18n="@@input-dialog-example.title" style="margin:auto;">
            Are you sure you want to Manually Acknowledge this record? When submitted, this action can not be reversed.
        </span>
    </div>
    <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
        <button one-secondary-button mat-stroked-button [mat-dialog-close]="true" title="Cancel" (click)="sendConfirmation('false')">Cancel</button>
        <button color="primary" mat-flat-button title="Submit" (click)="sendConfirmation('true')">Submit</button>
        <!-- [disabled]="!commentText.value" -->
    </div>
</div>
